import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/loader/Loadable';

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));

const Minimal = Loadable(lazy(() => import('../views/dashboards/Minimal')));
const Dash = Loadable(lazy(() => import('../views/dashboards/Dash')));
const Analytical = Loadable(lazy(() => import('../views/dashboards/Analytical')));
const Demographical = Loadable(lazy(() => import('../views/dashboards/Demographical')));
const Modern = Loadable(lazy(() => import('../views/dashboards/Modern')));

const Notes = Loadable(lazy(() => import('../views/apps/notes/Notes')));
const Chat = Loadable(lazy(() => import('../views/apps/chat/Chat')));
const Contacts = Loadable(lazy(() => import('../views/apps/contacts/Contacts')));
const Calendar = Loadable(lazy(() => import('../views/apps/calendar/CalendarApp')));
const Email = Loadable(lazy(() => import('../views/apps/email/Email')));
const Shop = Loadable(lazy(() => import('../views/apps/ecommerce/Shop')));
const ShopDetail = Loadable(lazy(() => import('../views/apps/ecommerce/ShopDetail')));
const Treeview = Loadable(lazy(() => import('../views/apps/treeview/TreeView')));
const TicketList = Loadable(lazy(() => import('../views/apps/ticket/TicketList')));
const TicketDetail = Loadable(lazy(() => import('../views/apps/ticket/TicketDetail')));

const Alerts = Loadable(lazy(() => import('../views/ui/Alerts')));
const Badges = Loadable(lazy(() => import('../views/ui/Badges')));
const Buttons = Loadable(lazy(() => import('../views/ui/Buttons')));
const Cards = Loadable(lazy(() => import('../views/ui/Cards')));
const Grid = Loadable(lazy(() => import('../views/ui/Grid')));
const Tables = Loadable(lazy(() => import('../views/ui/Tables')));
const Forms = Loadable(lazy(() => import('../views/ui/Forms')));
const Breadcrumbs = Loadable(lazy(() => import('../views/ui/Breadcrumbs')));
const Dropdowns = Loadable(lazy(() => import('../views/ui/DropDown')));
const BtnGroup = Loadable(lazy(() => import('../views/ui/BtnGroup')));
const Collapse = Loadable(lazy(() => import('../views/ui/Collapse')));
const ListGroup = Loadable(lazy(() => import('../views/ui/ListGroup')));
const Modal = Loadable(lazy(() => import('../views/ui/Modal')));
const Navbar = Loadable(lazy(() => import('../views/ui/Navbar')));
const Nav = Loadable(lazy(() => import('../views/ui/Nav')));
const Pagination = Loadable(lazy(() => import('../views/ui/Pagination')));
const Popover = Loadable(lazy(() => import('../views/ui/Popover')));
const Progress = Loadable(lazy(() => import('../views/ui/Progress')));
const Spinner = Loadable(lazy(() => import('../views/ui/Spinner')));
const Tabs = Loadable(lazy(() => import('../views/ui/Tabs')));
const Toasts = Loadable(lazy(() => import('../views/ui/Toasts')));
const Tooltip = Loadable(lazy(() => import('../views/ui/Tooltip')));

const FormBasic = Loadable(lazy(() => import('../views/form-layouts/FormBasic')));
const FormGrid = Loadable(lazy(() => import('../views/form-layouts/FormGrid')));
const FormGroup = Loadable(lazy(() => import('../views/form-layouts/FormGroup')));
const FormInput = Loadable(lazy(() => import('../views/form-layouts/FormInput')));

const Datepicker = Loadable(lazy(() => import('../views/form-pickers/DateTimePicker')));
const TagSelect = Loadable(lazy(() => import('../views/form-pickers/TagSelect')));

const FormValidate = Loadable(lazy(() => import('../views/form-validation/FormValidation')));
const FormSteps = Loadable(lazy(() => import('../views/form-steps/Steps')));
const FormEditor = Loadable(lazy(() => import('../views/form-editor/FormEditor')));

const Basictable = Loadable(lazy(() => import('../views/tables/TableBasic')));
const CustomReactTable = Loadable(lazy(() => import('../views/tables/CustomReactTable')));
const ReactBootstrapTable = Loadable(lazy(() => import('../views/tables/ReactBootstrapTable')));

const ApexCharts = Loadable(lazy(() => import('../views/charts/ApexCharts')));
const ChartJs = Loadable(lazy(() => import('../views/charts/ChartJs')));

const StarterKit = Loadable(lazy(() => import('../views/sample-pages/StarterKit')));
const Profile = Loadable(lazy(() => import('../views/sample-pages/Profile')));
const Gallery = Loadable(lazy(() => import('../views/sample-pages/Gallery')));
const SearchResult = Loadable(lazy(() => import('../views/sample-pages/SearchResult')));
const HelperClass = Loadable(lazy(() => import('../views/sample-pages/HelperClass')));

const Bootstrap = Loadable(lazy(() => import('../views/icons/Bootstrap')));
const Feather = Loadable(lazy(() => import('../views/icons/Feather')));

const CustomVectorMap = Loadable(lazy(() => import('../views/maps/CustomVectorMap')));

const Widget = Loadable(lazy(() => import('../views/widget/Widget')));

const CASL = Loadable(lazy(() => import('../views/apps/accessControlCASL/AccessControl')));

const Error = Loadable(lazy(() => import('../views/auth/Error')));
const RegisterFormik = Loadable(lazy(() => import('../views/auth/RegisterFormik')));
const LoginFormik = Loadable(lazy(() => import('../views/auth/LoginFormik')));
const Maintanance = Loadable(lazy(() => import('../views/auth/Maintanance')));
const LockScreen = Loadable(lazy(() => import('../views/auth/LockScreen')));
const RecoverPassword = Loadable(lazy(() => import('../views/auth/RecoverPassword')));
const ChangePassword = Loadable(lazy(() => import('../views/auth/ChangePassword')));

const MasterRoleTable = Loadable(lazy(() => import('../views/master/MasterRoleTable')));
const MasterUser = Loadable(lazy(() => import('../views/master/MasterUser')));
const MasterEmployee = Loadable(lazy(() => import('../views/master/MasterEmployee')));
const MasterEmployeeFiles = Loadable(lazy(() => import('../views/master/MasterEmployeeFiles')));
const MasterDepartment = Loadable(lazy(() => import('../views/master/MasterDepartment')));
const MasterBank = Loadable(lazy(() => import('../views/master/MasterBank')));
const MasterAllowance = Loadable(lazy(() => import('../views/master/MasterAllowance')));
const MasterDeduction = Loadable(lazy(() => import('../views/master/MasterDeduction')));
const MasterPosition = Loadable(lazy(() => import('../views/master/MasterPosition')));
const MasterJobdesc = Loadable(lazy(() => import('../views/master/MasterJobdesc')));
const MasterCategoryPosition = Loadable(lazy(() => import('../views/master/MasterCategoryPosition')));
const MasterWorkHour = Loadable(lazy(() => import('../views/master/MasterWorkHour')));
const MasterCompany = Loadable(lazy(() => import('../views/master/MasterCompany')));
const MasterSp = Loadable(lazy(() => import('../views/master/MasterSp')));

const EmployeeActiveGridList = Loadable(lazy(() => import('../views/Employee/employee-active-list/EmployeeActiveGridList')));

const EmployeeReport = Loadable(lazy(() => import('../views/reports/EmployeeReport')));
const InactiveEmployeeReport = Loadable(lazy(() => import('../views/reports/InactiveEmployeeReport')));
const EmployeeLoanReport = Loadable(lazy(() => import('../views/reports/EmployeeLoanReport')));
const PayrollReport = Loadable(lazy(() => import('../views/reports/PayrollReport')));
const KpiReport = Loadable(lazy(() => import('../views/reports/KpiReport')));

const SalaryChange = Loadable(lazy(() => import('../views/salary/SalaryChange')));

const MassDismissal = Loadable(lazy(() => import('../views/dismissal/MassDismissal')));

const MasterCalendar = Loadable(lazy(() => import('../views/master/calendar/Calendar')));

const EmployeeAllowanceGridList = Loadable(lazy(() => import('../views/Employee/employee-allowance/employeeAllowanceGridList')));
const EmployeeAllowanceInput = Loadable(lazy(() => import('../views/Employee/employee-allowance/employeeAllowanceInput')));
const EmployeeAllowanceEdit = Loadable(lazy(() => import('../views/Employee/employee-allowance/employeeAllowanceEdit')));

const EmployeeKpiAllowanceGridList = Loadable(lazy(() => import('../views/Employee/employee-kpi-allowance/EmployeeKpiAllowanceGridList')));
const EmployeeKpiAllowanceInput = Loadable(lazy(() => import('../views/Employee/employee-kpi-allowance/EmployeeKpiAllowanceInput')));
const EmployeeKpiAllowanceEdit = Loadable(lazy(() => import('../views/Employee/employee-kpi-allowance/EmployeeKpiAllowanceEdit')));

const EmployeeBankGridList = Loadable(lazy(() => import('../views/Employee/employee-bank/employeeBankGridList')));
const EmployeeBankInput = Loadable(lazy(() => import('../views/Employee/employee-bank/employeeBankInput')));
const EmployeeBankEdit = Loadable(lazy(() => import('../views/Employee/employee-bank/employeeBankEdit')));

const EmployeeDeductionGridList = Loadable(lazy(() => import('../views/Employee/employee-deduction/employeeDeductionGridList')));
const EmployeeDeductionInput = Loadable(lazy(() => import('../views/Employee/employee-deduction/employeeDeductionInput')));
const EmployeeDeductionEdit = Loadable(lazy(() => import('../views/Employee/employee-deduction/employeeDeductionEdit')));

const EmployeeLoanGridList = Loadable(lazy(() => import('../views/Employee/employee-loan/employeeLoanGridList')));
const EmployeeLoanInput = Loadable(lazy(() => import('../views/Employee/employee-loan/employeeLoanInput')));
const EmployeeLoanEdit = Loadable(lazy(() => import('../views/Employee/employee-loan/employeeLoanEdit')));

const PayrollGridList = Loadable(lazy(() => import('../views/transactions/payroll/PayrollGridList')));
const PayrollInput = Loadable(lazy(() => import('../views/transactions/payroll/PayrollInput')));
const PayrollEdit = Loadable(lazy(() => import('../views/transactions/payroll/PayrollEdit')));
const PayrollView = Loadable(lazy(() => import('../views/transactions/payroll/PayrollView')));

const KpiGridList = Loadable(lazy(() => import('../views/transactions/kpi/KpiGridList')));
const KpiInput = Loadable(lazy(() => import('../views/transactions/kpi/KpiInput')));
const KpiEdit = Loadable(lazy(() => import('../views/transactions/kpi/KpiEdit')));
const KpiView = Loadable(lazy(() => import('../views/transactions/kpi/KpiView')));

const ThemeRoutes = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', name: 'Home', element: <Navigate to="/dashboards" /> },
      { path: '/change-password', name: 'ChangePassword', element: <ChangePassword /> },
      { path: '/master/role', name: 'MasterRoleTable', element: <MasterRoleTable/>},
      { path: '/master/user', name: 'MasterUser', element: <MasterUser/>},
      { path: '/master/position', name: 'MasterPosition', element: <MasterPosition/>},
      { path: '/master/jobdesc', name: 'MasterJobdesc', element: <MasterJobdesc/>},
      { path: '/master/employee', name: 'MasterEmployee', element: <MasterEmployee/>},
      { path: '/master/employee-files', name: 'employee-files', element: <MasterEmployeeFiles /> },
      { path: '/reports/employee', name: 'employee-report', element: <EmployeeReport /> },
      { path: '/reports/inactive-employee', name: 'inactive-employee-report', element: <InactiveEmployeeReport /> },
      { path: '/reports/employee-loan', name: 'employee-loan-report', element: <EmployeeLoanReport /> },
      { path: '/reports/payroll', name: 'payroll report', exact: true, element: <PayrollReport /> },
      { path: '/reports/kpi-report', name: 'kpi-report', exact: true, element: <KpiReport /> },
      { path: '/master/department', name: 'MasterDepartment', element: <MasterDepartment/>},
      { path: '/master/bank', name: 'MasterBank', element: <MasterBank/>},
      { path: '/master/allowance', name: 'MasterAllowance', element: <MasterAllowance/>},
      { path: '/master/deduction', name: 'MasterDeduction', element: <MasterDeduction/>},
      { path: '/master/category-position', name: 'MasterCategoryPosition', element: <MasterCategoryPosition/>},
      { path: '/master/work-hour', name: 'MasterWorkHour', element: <MasterWorkHour/>},
      { path: '/master/company', name: 'MasterCompany', element: <MasterCompany/>},
      { path: '/hr/sp', name: 'Surat Peringatan', exact: true, element: <MasterSp/> },
      { path: '/salary/change', name: 'Salary Change', exact: true, element: <SalaryChange /> },
      { path: '/dismissal/mass-dismissal', name: 'mass-dismissal', exact: true, element: <MassDismissal />,},
      { path: '/employee/employee-active-list', name: 'Employee Active List', exact: true, element: <EmployeeActiveGridList /> },
      { path: '/employee/employee-allowance', name: 'Employee Allowance List', exact: true, element: <EmployeeAllowanceGridList /> },
      { path: '/employee/employee-allowance/input', name: 'Employee Allowance Input', exact: true, element: <EmployeeAllowanceInput /> },
      { path: '/employee/employee-allowance/edit/:id', name: 'Employee Allowance Edit', exact: true, element: <EmployeeAllowanceEdit /> },
      { path: '/employee/employee-kpi-allowance', name: 'employee-kpi-allowance', exact: true, element: <EmployeeKpiAllowanceGridList />,},
      { path: '/employee/employee-kpi-allowance/input', name: 'employee-kpi-allowance-input', exact: true, element: <EmployeeKpiAllowanceInput />, },
      { path: '/employee/employee-kpi-allowance/edit/:id', name: 'employee-kpi-allowance-edit', exact: true, element: <EmployeeKpiAllowanceEdit />, },
      { path: '/employee/employee-bank', name: 'Employee Bank List', exact: true, element: <EmployeeBankGridList /> },
      { path: '/employee/employee-bank/input', name: 'Employee Bank Input', exact: true, element: <EmployeeBankInput /> },
      { path: '/employee/employee-bank/edit/:id', name: 'Employee Bank Edit', exact: true, element: <EmployeeBankEdit /> },
      { path: '/employee/employee-deduction', name: 'Employee Deduction List', exact: true, element: <EmployeeDeductionGridList /> },
      { path: '/employee/employee-deduction/input', name: 'Employee Deduction Input', exact: true, element: <EmployeeDeductionInput /> },
      { path: '/employee/employee-deduction/edit/:id', name: 'Employee Deduction Edit', exact: true, element: <EmployeeDeductionEdit /> },
      { path: '/employee/employee-loan', name: 'Employee Loan List', exact: true, element: <EmployeeLoanGridList /> },
      { path: '/employee/employee-loan/input', name: 'Employee Loan Input', exact: true, element: <EmployeeLoanInput /> },
      { path: '/employee/employee-loan/edit/:id', name: 'Employee Loan Edit', exact: true, element: <EmployeeLoanEdit /> },
      { path: '/payroll', name: 'Payroll List', exact: true, element: <PayrollGridList /> },
      { path: '/payroll/input', name: 'Payroll Input', exact: true, element: <PayrollInput /> },
      { path: '/payroll/edit/:id', name: 'Payroll Edit', exact: true, element: <PayrollEdit /> },
      { path: '/payroll/view/:id', name: 'Payroll View', exact: true, element: <PayrollView /> },
      { path: '/kpi', name: 'Payroll List', exact: true, element: <KpiGridList /> },
      { path: '/kpi/input', name: 'Payroll Input', exact: true, element: <KpiInput /> },
      { path: '/kpi/edit/:id', name: 'Payroll Edit', exact: true, element: <KpiEdit /> },
      { path: '/kpi/view/:id', name: 'Payroll View', exact: true, element: <KpiView /> },
      { path: '/master/calendar', name: 'MasterCalendar', exact: true, element: <MasterCalendar /> },
      { path: '/dashboards/minimal', name: 'Minimal', exact: true, element: <Minimal /> },
      { path: '/dashboards', name: 'Dashboard', exact: true, element: <Dash /> },
      { path: '/dashboards/analytical', name: 'Analytical', exact: true, element: <Analytical /> },
      { path: '/dashboards/demographical', name: 'Demographical', exact: true, element: <Demographical /> },
      { path: '/dashboards/modern', name: 'Modern', exact: true, element: <Modern /> },
      { path: '/apps/notes', name: 'notes', exact: true, element: <Notes /> },
      { path: '/apps/chat', name: 'chat', exact: true, element: <Chat /> },
      { path: '/apps/contacts', name: 'contacts', exact: true, element: <Contacts /> },
      { path: '/apps/calendar', name: 'calendar', exact: true, element: <Calendar /> },
      { path: '/apps/email', name: 'email', exact: true, element: <Email /> },
      { path: '/ecom/shop', name: 'email', exact: true, element: <Shop /> },
      { path: '/ecom/shopdetail', name: 'email', exact: true, element: <ShopDetail /> },
      { path: '/tickt/ticket-list', name: 'ticket list', exact: true, element: <TicketList /> },
      { path: '/tickt/ticket-detail', name: 'ticket detail', exact: true, element: <TicketDetail /> },
      { path: '/apps/treeview', name: 'email', exact: true, element: <Treeview /> },
      { path: '/ui/alerts', name: 'alerts', exact: true, element: <Alerts /> },
      { path: '/ui/badges', name: 'badges', exact: true, element: <Badges /> },
      { path: '/ui/buttons', name: 'buttons', exact: true, element: <Buttons /> },
      { path: '/ui/cards', name: 'cards', exact: true, element: <Cards /> },
      { path: '/ui/grid', name: 'grid', exact: true, element: <Grid /> },
      { path: '/ui/table', name: 'table', exact: true, element: <Tables /> },
      { path: '/ui/forms', name: 'forms', exact: true, element: <Forms /> },
      { path: '/ui/breadcrumbs', name: 'breadcrumbs', exact: true, element: <Breadcrumbs /> },
      { path: '/ui/dropdown', name: 'dropdown', exact: true, element: <Dropdowns /> },
      { path: '/ui/button-group', name: 'button group', exact: true, element: <BtnGroup /> },
      { path: '/ui/collapse', name: 'collapse', exact: true, element: <Collapse /> },
      { path: '/ui/list-group', name: 'list-group', exact: true, element: <ListGroup /> },
      { path: '/ui/modal', name: 'modal', exact: true, element: <Modal /> },
      { path: '/ui/navbar', name: 'navbar', exact: true, element: <Navbar /> },
      { path: '/ui/nav', name: 'nav', exact: true, element: <Nav /> },
      { path: '/ui/pagination', name: 'pagination', exact: true, element: <Pagination /> },
      { path: '/ui/popover', name: 'popover', exact: true, element: <Popover /> },
      { path: '/ui/progress', name: 'progress', exact: true, element: <Progress /> },
      { path: '/ui/spinner', name: 'spinner', exact: true, element: <Spinner /> },
      { path: '/ui/tabs', name: 'tabs', exact: true, element: <Tabs /> },
      { path: '/ui/toasts', name: 'toasts', exact: true, element: <Toasts /> },
      { path: '/ui/tooltip', name: 'tooltip', exact: true, element: <Tooltip /> },
      { path: '/form-layout/form-basic', name: 'form-basic', exact: true, element: <FormBasic /> },
      { path: '/form-layout/form-grid', name: 'form-grid', exact: true, element: <FormGrid /> },
      { path: '/form-layout/form-group', name: 'form-group', exact: true, element: <FormGroup /> },
      { path: '/form-layout/form-input', name: 'form-input', exact: true, element: <FormInput /> },
      { path: '/form-pickers/datepicker', name: 'datepicker', exact: true, element: <Datepicker /> },
      { path: '/form-pickers/tag-select', name: 'tag-select', exact: true, element: <TagSelect /> },
      { path: '/form-validation', name: 'form-validation', exact: true, element: <FormValidate /> },
      { path: '/form-steps', name: 'form-steps', exact: true, element: <FormSteps /> },
      { path: '/form-editor', name: 'form-editor', exact: true, element: <FormEditor /> },
      { path: '/tables/basic-table', name: 'basic-table', exact: true, element: <Basictable /> },
      { path: '/tables/react-table', name: 'react-table', exact: true, element: <CustomReactTable /> },
      { path: '/tables/data-table', name: 'data-table', exact: true, element: <ReactBootstrapTable /> },
      { path: '/charts/apex', name: 'apex', exact: true, element: <ApexCharts /> },
      { path: '/charts/chartjs', name: 'chartjs', exact: true, element: <ChartJs /> },
      { path: '/sample-pages/profile', name: 'profile', exact: true, element: <Profile /> },
      { path: '/sample-pages/helper-class', name: 'helper-class', exact: true, element: <HelperClass /> },
      { path: '/sample-pages/starterkit', name: 'starterkit', exact: true, element: <StarterKit /> },
      { path: '/sample-pages/gallery', name: 'gallery', exact: true, element: <Gallery /> },
      { path: '/sample-pages/search-result', name: 'search-result', exact: true, element: <SearchResult /> },
      { path: '/icons/bootstrap', name: 'bootstrap', exact: true, element: <Bootstrap /> },
      { path: '/icons/feather', name: 'feather', exact: true, element: <Feather /> },
      { path: '/map/vector', name: 'vector', exact: true, element: <CustomVectorMap /> },
      { path: '/widget', name: 'widget', exact: true, element: <Widget /> },
      { path: '/casl', name: 'casl', exact: true, element: <CASL /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/print',
    element: <BlankLayout />,
    children: [
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
      { path: 'registerformik', element: <RegisterFormik /> },
      { path: 'loginformik', element: <LoginFormik /> },
      { path: 'maintanance', element: <Maintanance /> },
      { path: 'lockscreen', element: <LockScreen /> },
      { path: 'recoverpwd', element: <RecoverPassword /> },
    ],
  },
];

export default ThemeRoutes;